import React, { useState } from "react"
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import EditIcon from "@mui/icons-material/Edit"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import { COLORS } from "../../../../utils"

const ROLE_LABELS = {
  buyer: "Acheteur",
  direction: "Direction",
  operations: "Exploitation",
  billing: "Facturation",
  other: "Autre",
}

const getRoleLabel = (role) => ROLE_LABELS[role] || role

const ContactCard = ({ contact, onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const menuOpen = Boolean(anchorEl)

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget)
  const handleMenuClose = () => setAnchorEl(null)

  const handleEdit = () => {
    handleMenuClose()
    onEdit(contact)
  }

  const handleDelete = () => {
    handleMenuClose()
    onDelete(contact)
  }

  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ")

  return (
    <Box sx={sx.card}>
      <Box className="flexColumn" sx={sx.body}>
        <Typography sx={sx.name}>{fullName}</Typography>

        <Box sx={sx.grid}>
          <Box className="flexColumn" sx={sx.kv}>
            <Typography sx={sx.kvLabel}>Email</Typography>
            <Typography sx={contact.email ? sx.kvValue : sx.kvEmpty}>{contact.email || "—"}</Typography>
          </Box>
          <Box className="flexColumn" sx={sx.kv}>
            <Typography sx={sx.kvLabel}>Rôle</Typography>
            <Typography sx={contact.role ? sx.kvValue : sx.kvEmpty}>{contact.role ? getRoleLabel(contact.role) : "—"}</Typography>
          </Box>
          <Box className="flexColumn" sx={sx.kv}>
            <Typography sx={sx.kvLabel}>Téléphone</Typography>
            <Typography sx={contact.phone ? sx.kvValue : sx.kvEmpty}>{contact.phone || "—"}</Typography>
          </Box>
        </Box>
      </Box>

      <Box>
        <IconButton size="small" onClick={handleMenuOpen}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose} PaperProps={{ sx: sx.menuPaper }}>
          <MenuItem className="flexRow center" onClick={handleEdit} sx={sx.menuItem}>
            <EditIcon sx={sx.menuIcon} />
            Modifier
          </MenuItem>
          <MenuItem className="flexRow center" onClick={handleDelete} sx={{ ...sx.menuItem, color: "error.main" }}>
            <DeleteOutlineIcon sx={{ ...sx.menuIcon, color: "error.main" }} />
            Supprimer
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}


const sx = {
  card: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: "12px 16px",
    alignItems: "flex-start",
    p: 2,
    border: "1px solid",
    borderColor: COLORS.GREY_ORDER_BORDER,
    borderRadius: 2,
    bgcolor: "background.paper",
    mb: 2,
    "&:last-child": { mb: 0 },
  },
  body: {
    minWidth: 0,
    gap: 3,
  },
  name: {
    fontSize: 16,
    fontWeight: 500,
    color: "text.primary",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "12px 24px",
    mt: 3,
  },
  kv: {
    minWidth: 0,
    gap: 1,
  },
  kvLabel: {
    fontSize: 12,
    color: "text.secondary",
    letterSpacing: "0.02em",
    fontWeight: 500,
  },
  kvValue: {
    fontSize: 14,
    color: "text.primary",
    lineHeight: 1.4,
  },
  kvEmpty: {
    fontSize: 14,
    color: "text.disabled",
    fontStyle: "italic",
  },
  menuPaper: {
    minWidth: 160,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },
  menuItem: {
    gap: 1,
    px: 2,
    py: 2,
    fontSize: 14,
    color: "text.primary",
  },
  menuIcon: {
    fontSize: "18px !important",
    color: "text.secondary",
  },
}

export default ContactCard
